import qs from "query-string";
import * as _ from "lodash";

class UrlServiceClass {
  getQueryStringValue = (key, queryString = window.location.search) => {
    const values = qs.parse(queryString, { decode: false });
    const rawVal = values[key];
    if (typeof rawVal !== "string") return rawVal;
    try {
      return rawVal.replace(/%([0-9A-F]{2})/gi, (_, hex) =>
        String.fromCharCode(parseInt(hex, 16))
      );
    } catch {
      return rawVal;
    }
  };

  setQueryStringWithoutPageReload = (qsValue) => {
    const newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      qsValue;

    window.history.replaceState({ path: newurl }, "", newurl);
  };

  setQueryStringValue = (key, value, queryString = window.location.search) => {
    const values = qs.parse(queryString);
    const newQsValue = qs.stringify({ ...values, [key]: value }, { encode: false });

    this.setQueryStringWithoutPageReload(`?${newQsValue}`);
  };

  setMultipleQueryStringValues = (
    keyValuePair,
    queryString = window.location.search
  ) => {
    const values = qs.parse(queryString);
    const updatedKeyValuePair = { ...values, ...keyValuePair };
    Object.keys(updatedKeyValuePair).forEach(
      (key) => !updatedKeyValuePair[key] && delete updatedKeyValuePair[key]
    );
    const newQsValue = qs.stringify({ ...updatedKeyValuePair }, { encode: false });
    this.setQueryStringWithoutPageReload(`?${newQsValue}`);
  };

  removeParam = (key, sourceURL = window.location.href) => {
    let urlparts = sourceURL.split("?");
    let urlBase = urlparts.shift();
    let queryString = urlparts.join("?");
    let pars = queryString.split(/[&;]/g);
    let prefix = key + "=";
    for (let i = pars.length; i-- > 0; )
      if (pars[i].lastIndexOf(prefix, 0) !== -1) pars.splice(i, 1);

    let url = urlBase + "?" + pars.join("&");
    window.history.replaceState("", document.title, url);
  };

  objectToQueryString = (requestedParams) => {
    let queryString = "";
    const validParams = _.omitBy(
      requestedParams,
      (v) =>
        _.isUndefined(v) ||
        _.isNull(v) ||
        v === "" ||
        (Array.isArray(v) && v.length === 0)
    );
    const keys = Object.keys(validParams);
    for (let key of keys) {
      const val = typeof validParams[key] === "string"
        ? validParams[key].replace(/\+/g, "%2B")
        : validParams[key];
      queryString += `${key}=${val}&`;
    }
    return queryString.slice(0, queryString.length - 1);
  };

  logoutFromDevice = () => {
    localStorage.clear();
    window.location.href = "/login";
  };
}

export const urlService = new UrlServiceClass();
